// extracted by mini-css-extract-plugin
module.exports = {"root":"Ahub-module--root--32aRM","my40":"Ahub-module--my40--1ujp5"};